export default __webpack_public_path__ + "static/renovated-issue-tracker-65fef70b1966280cced1d7cb799377d4.png";